import React, {FC} from 'react';
import {Info} from '@epic-ui/icons';
import Box, {BoxProps} from '@material-ui/core/Box';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

export interface TooltipIconButtonProps extends BoxProps {
    isOpen: boolean;
    onPopoverOpen: () => void;
    onPopoverClose: () => void;
}

const TooltipIconButton: FC<TooltipIconButtonProps> = ({
    onPopoverOpen,
    onPopoverClose,
    isOpen
}: TooltipIconButtonProps) => {
    const handleClick = event => {
        event.stopPropagation();

        if (isOpen) {
            onPopoverClose();
        } else {
            onPopoverOpen();
        }
    };

    const handleMouseOver = () => {
        setTimeout(onPopoverOpen, 0);
    };

    return (
        <ClickAwayListener onClickAway={onPopoverClose}>
            <Box
                mx={2}
                my="-2px"
                display="flex"
                alignItems="center"
                onMouseLeave={onPopoverClose}
                onMouseOver={handleMouseOver}
                onFocus={handleClick}
                onClick={handleClick}>
                <Info color="disabled" />
            </Box>
        </ClickAwayListener>
    );
};

export default TooltipIconButton;
